import { backdropClasses } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    overflowY: "auto",
  },
  tableWrapper: {
    paddingBlock: 12,
  },
  tiplistoperators:{

  },
  metricboxes:{

  },
  metricbox:{
    position:"relative",
  "& .MuiBox-root":{
    width:"90%",
    height:150,
    margin: "0 auto",
    padding: 20,
  },
  "& .MuiSvgIcon-root":{
  fontSize: 86,
  position:"absolute",
  top:67,
  right:44,
  color: "#02020254",
  },
  },
  Endbtn:{
   padding: "0 8px !important"
  },
  filters:{
  "& .MuiTextField-root":{
 width:"83% !important",
  },
  "& .makeStyles-datePickerStyle-229":{
    width:"83% !important",
  }
  },
  utilities:{
     textAlign:"center",
     paddingBlock: 20,
  },
  datePickerStyle: {
    "& .css-1jbvi91-MuiFormControl-root-MuiTextField-root": {
      width: "100%",
    },
    "& .css-1h0hk72-MuiFormLabel-root-MuiInputLabel-root": {
      top: "-5px",
    },
    "& .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "10px",
    },
  },
  layout: {
    background: "#EAEDEF",
    height: "calc(100vh - 70px)",
    overflowY: "auto",
  },
  title: {
    display: "flex",
    gap: 12,
    justifyContent: "center",
    padding: "20px 0px",
  },
  pages: {
    background: "#fff",
    borderRadius: 8,
  },
  editIcon: {
    border: `1px solid #11823b`,
    display: "flex",
    justifyContent: "center",
    borderRadius: 5,
    padding: 2,
    alignItems: "center",
    background: "#11823b",
    "& .MuiSvgIcon-root": {
      color: "#ffffff",
      cursor: "pointer",
      fontSize: 20,
    },
  },
  deleteIcon: {
    border: `1px solid #ff2020db`,
    display: "flex",
    justifyContent: "center",
    borderRadius: 5,
    padding: 2,
    alignItems: "center",
    background: "#ff2020db",
    "& .MuiSvgIcon-root": {
      color: "#ffffff",
      cursor: "pointer",
      fontSize: 20,
    },
  },
  historyIcon:{
    border: `1px solid #f140a9`,
    display: "flex",
    justifyContent: "center",
    borderRadius: 5,
    padding: 2,
    alignItems: "center",
    background: "#000000",
    "& .MuiSvgIcon-root": {
      color: "#ffffff",
      cursor: "pointer",
      fontSize: 20,
    },
  },
  actiontypo:{
    padding: 2,
    color:"#fff",
    "&.MuiTypography-subtitle2":{
      fontSize: 14,
    },
  },
  tableHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    rowGap: 8,
    "& .MuiTypography-root": {
      fontWeight: 500,
    },
    "& .MuiButton-root": {
      color: "gray",
      textTransform: "capitalize",
      border: "1px solid #c5baba",
      "&:hover": {
        border: "1px solid #848181",
        backgroundColor: "#fff",
      },
    },
  },
  dataGridTable: {
    paddingBlock: 20,
    "& .MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeaders": {
      background: "#1D426D33",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      textTransform: "uppercase",
      fontSize: 14,
    },
    "& .MuiDataGrid-iconSeparator ": {
      display: "none",
    },
    "& .MuiDataGrid-virtualScroller": {
      scrollbarWidth: "thin",
      "&::-webkit-scrollbar": {
        height: 6,
      },
    },
    "& .MuiDataGrid-footerContainer": {
      justifyContent: "flex-start",
    },
    "& .MuiTablePagination-selectLabel": {
      fontSize: 13,
    },
    "& .MuiTablePagination-displayedRows": {
      fontSize: 13,
    },
    "& .MuiTablePagination-select": {
      fontSize: 13,
    },
    "& .MuiDataGrid-cell":{
      whiteSpace: "normal !important",
      wordWrap: "break-word",
    },
  },
  lightText: {
    "& .MuiTypography-root": {
      color: "rgba(0, 0, 0, 0.7)",
    },
  },
  linkText: {
    "& .MuiTypography-root": {
      color: "#0f5fff",
      cursor: "pointer",
    },
  },
  spacing: {
    paddingBlockStart: 4,
  },
  iconsWrapper: {
    display: "flex",
    gap: 8,
    "& .MuiButtonBase-root":{
      background:"#3588fe",
      color:"#fff",
      padding: 2,
      borderRadius: 15,
    },
  },
  status:{
      color:"#fff",
      padding: 6,
      borderRadius: 15, 
  },
  deleteIcon: {
    border: `1px solid #ff2020db`,
    display: "flex",
    justifyContent: "center",
    borderRadius: 5,
    padding: 2,
    alignItems: "center",
    background: "#ff2020db",
    "& .MuiSvgIcon-root": {
      color: "#ffffff",
      cursor: "pointer",
      fontSize: 20,
    },
  },
}));


export default useStyles;
